import { Instagram, ArrowUpRight } from "lucide-react";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, INSTAGRAM_POSTS } from "../lib/instagram";

export default function InstagramStrip() {
  const posts = INSTAGRAM_POSTS;
  if (!posts || posts.length === 0) return null;

  const isSingle = posts.length === 1;
  const gridCols = isSingle
    ? "lg:grid-cols-12"
    : posts.length === 2
    ? "grid-cols-1 md:grid-cols-2"
    : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3";

  return (
    <section className="bg-sand py-24" data-testid="instagram-strip">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
          <div>
            <div className="overline mb-4">Latest on Instagram</div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-navy leading-tight">
              Follow along as we <em className="italic">set sail</em>.
            </h2>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 border border-navy text-navy px-5 py-3 text-[0.72rem] tracking-[0.22em] uppercase hover:bg-navy hover:text-white transition-colors"
            data-testid="instagram-follow-cta"
          >
            <Instagram size={14} strokeWidth={1.6} /> Follow @{INSTAGRAM_HANDLE}
          </a>
        </div>

        {isSingle ? (
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <a
              href={posts[0].url}
              target="_blank"
              rel="noreferrer"
              className="lg:col-span-7 block group relative overflow-hidden"
              data-testid="instagram-post-launch"
            >
              <img
                src={posts[0].image}
                alt="Latest Instagram post"
                className="w-full aspect-square object-cover transition-transform duration-[1200ms] group-hover:scale-[1.02]"
              />
              <div className="absolute top-4 right-4 w-10 h-10 bg-white/95 backdrop-blur flex items-center justify-center text-navy">
                <Instagram size={16} strokeWidth={1.6} />
              </div>
            </a>
            <div className="lg:col-span-5">
              {posts[0].callout && (
                <p className="font-serif-display italic text-3xl text-navy/70 mb-6">
                  {posts[0].callout}
                </p>
              )}
              <p className="text-[color:var(--am-muted)] leading-relaxed">
                "{posts[0].caption}"
              </p>
              <a
                href={posts[0].url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-navy border-b border-navy pb-1 mt-8 text-sm tracking-[0.2em] uppercase font-medium hover:gap-3 transition-all"
                data-testid="instagram-view-post"
              >
                View post <ArrowUpRight size={14} />
              </a>
            </div>
          </div>
        ) : (
          <div className={`grid ${gridCols} gap-5`}>
            {posts.map((p) => (
              <a
                key={p.id}
                href={p.url}
                target="_blank"
                rel="noreferrer"
                className="block group relative overflow-hidden"
                data-testid={`instagram-post-${p.id}`}
              >
                <img
                  src={p.image}
                  alt={p.caption?.slice(0, 80) || "Instagram post"}
                  className="w-full aspect-square object-cover transition-transform duration-[1200ms] group-hover:scale-[1.02]"
                />
                <div className="absolute top-3 right-3 w-9 h-9 bg-white/95 backdrop-blur flex items-center justify-center text-navy">
                  <Instagram size={14} strokeWidth={1.6} />
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
